import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionContext = /*#__PURE__*/createContext({
  question: undefined
});
export var QuestionContextProvider = function QuestionContextProvider(_ref) {
  var children = _ref.children,
      question = _ref.question;
  // Memoize value to ensure stable reference unless question changes
  // This helps child components (like Tiptap NodeViews) to properly detect changes
  var value = useMemo(function () {
    return {
      question: question
    };
  }, [question]);
  return /*#__PURE__*/_jsx(QuestionContext.Provider, {
    value: value,
    children: children
  });
};
export var useQuestionContext = function useQuestionContext() {
  var context = useContext(QuestionContext);

  if (!context) {
    throw new Error('useQuestionContext must be used within a QuestionContextProvider');
  }

  return context;
};